import React from 'react';
import styled from 'styled-components';

// import '@etchteam/next-pagination/dist/index.css';
import { Pagination } from '@/components/Pagination/Pagination';

export const PaginationBlock = ({ data }) => {
  return (
    <Footer>
      <Pagination
        currentPage={data?.current_page}
        pageSize={+data?.per_page}
        total={data?.total}
      />
    </Footer>
  );
};

const Footer = styled.div`
  width: 100%;
  padding: 40px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
